import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
    iconContainer: {
        height: 24,
        justifyContent: 'center',
        alignItems: 'center',
    },
});

export default styles;
